import styled from "styled-components";

export const Portait3Style = styled.div`
width: 100%;
height: 100%;

.img-fluid {
  display: block;
  max-width: 100%;
}

.container7 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.f-white {
  color: #fff;
}

.f-pippin {
  color: #ffe0db;
}

.f-cinnabar {
  color: #ec4f43;
}

.text-wrapper div {
  width: 100%;
  text-align:right;
}

.back-layer {
  width: 100%;
  height: 100%;
}

.back-layer img,
.back-layer video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: rotateY(180deg);
  position:absolute
}

.shape-wrap {
  width: 110%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;  
  right:27%;
  filter: drop-shadow(10px 0px 40px rgba(0 0 0 / 50%));
  transform: scale(1.5);
}

.shape {
  position: absolute;
  background: #fe948d;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  // right:35%;
  clip-path: polygon(55% 0, 100% 0, 100% 100%, 55% 100%, 0 50%);
}

.text-wrapper {
  z-index: 1;
  position: absolute;
  top: 0;
  right:-5px;
  width: 56%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
`;
